import { FC } from 'react'
import { Box } from '@mui/material'
import CourseSetupMainForm from 'components/organisms/forms/CourseSetupMainForm'
import CourseSetupDetailsForm from 'components/organisms/forms/CourseSetupDetailsForm'
import CourseSetupGradingForm from 'components/organisms/forms/CourseSetupGradingForm'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'

const CourseSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>

      <PageHeading title={t('common.curriculum')} />
      <Box sx={{padding: '30px'}} mb={3}><CourseSetupMainForm /></Box>

      <PageHeading title={t('common.course-planning-panel')} />
      <Box sx={{padding: '30px'}}><CourseSetupDetailsForm /></Box>

      <PageHeading title={t('common.grading-plan')} />
      <Box sx={{padding: '30px'}}><CourseSetupGradingForm /></Box>
    </Box>
  )
}
export default CourseSetupPage
